
import { defineComponent } from 'vue';
import { State, Topic } from '@/types';
import { generateTitle } from '@/utils';
import { store } from '@/state';

export default defineComponent({
  props: {
    topic: {
      type: Object as () => Topic,
      required: true
    },
    loggedIn: {
      type: Boolean
    }
  },
  data () {
    return {
      state: store.state as State
    }
  },
  computed: {
    lastAppliedLabel (): string {
      const foundEntriesInHistory = this.state.history
        .filter(h => h.topicId === this.topic.id);

      if (foundEntriesInHistory.length > 0) {
        foundEntriesInHistory.sort(function (a, b) {
          if (!a.date || !b.date) {
            return 0;
          }

          // Turn your strings into dates, and then subtract them
          // to get a value that is either negative, positive, or zero.
          return Number(new Date(b.date)) - Number(new Date(a.date));
        });

        const latestEntry = foundEntriesInHistory[0];

        return `${new Date(latestEntry.date!).toLocaleString()} with the Title:  ${latestEntry.lastTitle}`;
      }

      console.info({ foundEntriesInHistory });

      return '';
    }
  },
  methods: {
    generateTitle (topic: Topic) {
      return generateTitle(topic);
    }
  }
});
